'use strict';

/**
 * Pict-Provider-OpsAPI
 * --------------------
 * Browser client for the platform ops console (GET /1.0/Admin/Ops). One read backs the
 * whole screen: grouped errors, the activity feed, who is active now, and recent deploys.
 * Platform-admin only (the server gates it). See design/Observability-Plan.md.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'OpsAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderOpsAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	initializeAppData()
	{
		if (!this.fable.AppData.Ops)
		{
			this.fable.AppData.Ops =
			{
				Loaded: false, LoadError: null,
				Summary: {}, Errors: [], ActiveUsers: [], Activity: [], Deploys: []
			};
		}
	}

	loadOps()
	{
		this.initializeAppData();
		let tmpStore = this.fable.AppData.Ops;
		return libFrameworkClient.getJSON(this.fable, this.routePrefix + 'Admin/Ops')
			.then((pBody) =>
			{
				tmpStore.Summary = pBody.Summary || {};
				tmpStore.Errors = pBody.Errors || [];
				tmpStore.ActiveUsers = pBody.ActiveUsers || [];
				tmpStore.Activity = pBody.Activity || [];
				tmpStore.Deploys = pBody.Deploys || [];
				tmpStore.Loaded = true;
				tmpStore.LoadError = null;
				return pBody;
			})
			.catch((pError) => { tmpStore.LoadError = pError.message; tmpStore.Loaded = true; return null; });
	}

	// The caller's own org activity (tenant-scoped, server-gated to org admins).
	loadOrgActivity(pFilters)
	{
		if (!this.fable.AppData.OrgActivity)
		{
			this.fable.AppData.OrgActivity = { Loaded: false, LoadError: null, Rows: [], Filters: {} };
		}
		let tmpStore = this.fable.AppData.OrgActivity;
		let tmpFilters = pFilters || {};
		tmpStore.Filters = tmpFilters;
		let tmpParams = [];
		if (tmpFilters.user) { tmpParams.push('user=' + encodeURIComponent(tmpFilters.user)); }
		if (tmpFilters.action) { tmpParams.push('action=' + encodeURIComponent(tmpFilters.action)); }
		tmpParams.push('count=' + (tmpFilters.count || 150));
		return libFrameworkClient.getJSON(this.fable, this.routePrefix + 'Org/Activity?' + tmpParams.join('&'))
			.then((pBody) => { tmpStore.Rows = (pBody && pBody.Activity) || []; tmpStore.Loaded = true; tmpStore.LoadError = null; return pBody; })
			.catch((pError) => { tmpStore.LoadError = pError.message; tmpStore.Loaded = true; return null; });
	}

	// The caller's pre-aggregated System Activity buckets for one granularity (tenant-scoped by session,
	// served from the pre-computed ActivityAggregate table). Powers the System Activity chart.
	loadActivityAggregate(pFilters)
	{
		if (!this.fable.AppData.SystemActivity)
		{
			this.fable.AppData.SystemActivity = { Loaded: false, LoadError: null, Period: 'Week', Rows: [] };
		}
		let tmpStore = this.fable.AppData.SystemActivity;
		let tmpFilters = pFilters || {};
		let tmpPeriod = tmpFilters.period || tmpStore.Period || 'Week';
		let tmpParams = ['period=' + encodeURIComponent(tmpPeriod)];
		if (tmpFilters.from) { tmpParams.push('from=' + encodeURIComponent(tmpFilters.from)); }
		if (tmpFilters.to) { tmpParams.push('to=' + encodeURIComponent(tmpFilters.to)); }
		if (tmpFilters.domain) { tmpParams.push('domain=' + encodeURIComponent(tmpFilters.domain)); }
		return libFrameworkClient.getJSON(this.fable, this.routePrefix + 'Activity/Aggregate?' + tmpParams.join('&'))
			.then((pBody) => { tmpStore.Period = (pBody && pBody.Period) || tmpPeriod; tmpStore.Rows = (pBody && pBody.Rows) || []; tmpStore.Loaded = true; tmpStore.LoadError = null; return pBody; })
			.catch((pError) => { tmpStore.LoadError = pError.message; tmpStore.Loaded = true; return null; });
	}
}

module.exports = PictProviderOpsAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;
